export class RegexHelper {
  static readonly dateRegex = new RegExp('^\\d{2}[/-]\\d{2}[/-](\\d{2}|\\d{4})$');
  static readonly floatRegex = new RegExp('^(\\d*[.,])?\\d+$');
  static readonly floatWithNegativeSignRegex = new RegExp('^-?(\\d*[.,])?\\d+$');
  static readonly sirenRegex = new RegExp('^\\d{3}(?: \\d{3}){2}$');
  static readonly amountIntervalRegex = /^([><]-?(\d*[.,])?\d+,[><]-?(\d*[.,])?\d+)$/;
  static readonly dateIntervalRegex = /^>=?\d{4}-\d{2}-\d{2},<=?\d{4}-\d{2}-\d{2}$/;
  static readonly passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{12,}$/;
}
